"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bullet = exports.bulletClassName = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BulletGlyph_1 = require("./BulletGlyph");
const BulletHalo_1 = require("./BulletHalo");
const BulletSquigglyRing_1 = require("./BulletSquigglyRing");
const settings_1 = require("./settings");
exports.bulletClassName = 'mutxt-step-bullet';
const bulletClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    w: `${settings_1.INDICATOR_SIZE}px`,
    h: `${settings_1.INDICATOR_SIZE}px`,
    bdrad: '50%',
    d: 'flex',
    ai: 'center',
    jc: 'center',
    bxz: 'border-box',
    fz: '13px',
    fw: 600,
    lh: '1',
    us: 'none',
    flexShrink: 0,
    trs: 'background-color .08s ease, border-color .08s ease, color .08s ease, box-shadow .08s ease, transform .08s ease',
    overflow: 'hidden',
    willChange: 'transform',
    backfaceVisibility: 'hidden',
    '&:hover': {
        bxsh: '0 0 0 4px rgba(127,127,127,0.14)',
        transform: 'scale(1.04)',
    },
    '&:active': {
        transform: 'scale(0.97)',
    },
});
const glyphWrapClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'center',
    w: '100%',
    h: '100%',
    lh: '1',
    ['textBoxTrim']: 'trim-both',
    ['textBoxEdge']: 'cap alphabetic',
});
const cssBorderStyleFor = (style) => {
    switch (style) {
        case 'none':
        case 'squiggly':
            return { borderStyle: 'none', borderWidth: 0 };
        case 'solid':
        case 'dashed':
        case 'dotted':
            return { borderStyle: style };
    }
};
/**
 * Single step's visual disc. Combines the inner glyph, the bullet ring (CSS
 * border for plain styles or SVG for `squiggly`), and an optional outer halo.
 * State governs the default colors of all three parts, props let the caller
 * override any of them.
 */
const Bullet = ({ state, indicator, chars, index, bg, glyphColor, ring, ringColor, ringWidth, halo, haloColor, haloWidth, }) => {
    const isSquigglyRing = ring === 'squiggly' && ringWidth > 0;
    const showCssBorder = ring !== 'none' && ring !== 'squiggly' && ringWidth > 0;
    const borderStyles = cssBorderStyleFor(showCssBorder ? ring : 'none');
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: `${bulletClass} ${exports.bulletClassName}`, style: {
                background: isSquigglyRing ? 'transparent' : bg,
                color: glyphColor,
                ...borderStyles,
                ...(showCssBorder ? { borderWidth: ringWidth, borderColor: ringColor } : null),
                ...(isSquigglyRing ? { overflow: 'visible' } : null),
            } },
            isSquigglyRing && React.createElement(BulletSquigglyRing_1.BulletSquigglyRing, { strokeColor: ringColor, strokeWidth: ringWidth }),
            React.createElement("span", { className: glyphWrapClass },
                React.createElement(BulletGlyph_1.BulletGlyph, { state: state, indicator: indicator, chars: chars, index: index, color: glyphColor }))),
        React.createElement(BulletHalo_1.BulletHalo, { style: halo, color: haloColor, strokeWidth: haloWidth })));
};
exports.Bullet = Bullet;
